export default __webpack_public_path__ + "0567ecc9fb69af842e4617bf521df95a.svg";